import { get, post, del, put } from '@api/request';

export const fetchSearchResultConfig = async (
  { queueService },
  authenticationToken,
) => {
  const url = `${queueService}/queue/workitems/search/resultsconfig`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export async function searchWorkItem(
  { queueService },
  authenticationToken,
  {
    pageSize,
    page,
    payload,
    // sortField,
    // sortDirection,
    // sortField1,
    // sortDirection1,
    // filterModel,
  },
) {
  let url = `${queueService}/queue/workitems/search?page=${page}&pageSize=${pageSize}`;
  // if (sortField && sortDirection) {
  //   url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
  // }

  // if (sortField1 && sortDirection1) {
  //   url += `&sortField1=${sortField1}&sortDirection1=${sortDirection1}`;
  // }

  // if (sortField2 && sortDirection2) {
  //   url += `&sortField2=${sortField2}&sortDirection2=${sortDirection2}`;
  // }

  // if (sortField3 && sortDirection3) {
  //   url += `&sortField3=${sortField3}&sortDirection3=${sortDirection3}`;
  // }

  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteWorkItem(
  { queueService },
  authenticationToken,
  { workItemID },
) {
  const url = `${queueService}/queue/workitem/${workItemID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function deleteWorkItems(
  { queueService },
  authenticationToken,
  { payload },
) {
  const url = `${queueService}/queue/workitems/massdelete`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}
